import { customToast } from "../../App";

export const getFormattedDateTime = () => {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Month is zero-based
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  const formattedDateTime = `${year}${month}${day}_${hours}${minutes}${seconds}`;

  return formattedDateTime;
};

export const processDownloadedChunk = async (
  chunksArr: any,
  receLen: any,
  fileName: string,
  props: any
) => {
  let chunksAll = new Uint8Array(receLen);
  let position = 0;
  for (let chunk of chunksArr) {
    chunksAll.set(chunk, position);
    position += chunk?.length;
  }

  const blob = new Blob([chunksAll]);
  const urlObject = URL.createObjectURL(blob);

  // Create a link and click it to start the download
  const link = document.createElement("a");
  link.href = urlObject;
  link.download = fileName;
  props.setDownloadProgress(false);
  props.setSelectedRow([]);
  props.setDisablefunc(true);
  props.setDownHandelClick(false);
  props.resetChunkProperties();
  customToast(`File Downloaded!`, "success");
  link.click();
  // refreshCurrentPageOfTable();
  setTimeout(() => URL.revokeObjectURL(urlObject), 60 * 1000);
};

export const getInitalPathName = (xval: any) => {
  const newFolderName = "My_folder";
  const folderNames: String[] = [];
  if (xval.length > 0) {
    xval.forEach((item: any) => {
      if (item.path.includes("/") || item.path === "") {
        return "/";
      } else {
        folderNames.push(item.path);
      }
    });
  }
  if (folderNames.length > 0) {
    let count = 1;
    while (true) {
      if (folderNames.includes(newFolderName + `_${count}`)) {
        count++;
      } else {
        return newFolderName + `_${count}`;
      }
    }
  } else {
    return newFolderName;
  }
};

export const checkFileAndFolder = (
  name: any,
  newArr: any,
  setemptyFldrName: any,
  setNameLength: any,
  setFexist: any
) => {
  const folderPresent = newArr.find(
    (folder: any) =>
      folder?.path?.trimEnd().toLowerCase() === name.trimEnd().toLowerCase()
  );
  if (name.length === 0) {
    setemptyFldrName(true);
    return true;
  } else if (name.length > 100) {
    setNameLength(true);
    return true;
  }
  if (folderPresent) {
    setFexist(true);
    return true;
  } else {
    setFexist(false);
    return false;
  }
};

export const convertDataGB = (val: any, type: any) => {
  let gbVal;
  if (type?.toLowerCase() === "kb") {
    gbVal = val / 1024 / 1024;
  }
  if (type?.toLowerCase() === "mb") {
    gbVal = val / 1024;
  }
  return gbVal;
};
export const splitFun = (input: any) => {
  const splitArray = input.match(/([\d\.]+)(.*)/);
  return {
    numeric: splitArray?.[1],
    nonnumeric: splitArray?.[2],
  };
};

export const blobFlow = async (blobSize: any, setConsumedBlobState: any) => {
  if (blobSize?.message?.consumedSize === "0Bytes") {
    setConsumedBlobState(0);
  } else if (blobSize?.message?.consumedSize) {
    let consize = splitFun(blobSize?.message?.consumedSize);
    if (consize.nonnumeric.toLowerCase() !== "gb") {
      let resConsume = convertDataGB(consize.numeric, consize.nonnumeric);
      if (resConsume) {
        // let roundNum = Math.round(resConsume);
        setConsumedBlobState(resConsume);
      }
    } else {
      if (consize.numeric) {
        setConsumedBlobState(consize.numeric);
      }
    }
  }
};
export const verifyFile = (file: any, setSymlinkError: any) => {
  const maxFileSize = 2147483648;
  if (file.size > maxFileSize) {
    customToast(
      "File Size Is Exceeding 2GB. Please Upload A File Smaller Than 2GB.",
      "critical"
    );
    return false;
  }
  //Symlink code
  if (
    file.type === "application/x-symlink" ||
    file.type === "application/x-hardlink"
  ) {
    setSymlinkError(true);
    return false;
  }
  return true;
};

export const uploadValidationPopupEvent = (
  event: any,
  resetFileInput: any,
  rowKey: any,
  setUploadValidateOpen: any,
  setFileNameUpload: any
) => {
  resetFileInput();
  rowKey.current = "";
  event.preventDefault();
  setUploadValidateOpen(false);
  setFileNameUpload("");
  return;
};
export const filealreadyexistEvent = (setFexist: any, inputEle: any) => {
  setFexist(false);
  inputEle.current.focus();
};
// Folder Name can not be empty
export const folderNameCantBeEmptyEvent = (
  setemptyFldrName: any,
  inputEle: any
) => {
  setemptyFldrName(false);
  inputEle.focus();
};
export const nameLengthEvent = (
  setNameLength: any,
  resetChunkProperties: any
) => {
  setNameLength(false);
  resetChunkProperties();
};
